import styled from 'styled-components';

export const StyledAppleMaps = styled.div``;
